import * as React from 'react';

const SvgIconCamera = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M21.204 7.09h-3.068L16.091 3H7.909L5.864 7.09H2.795C1.665 7.09.75 8.008.75 9.137v10.228c0 1.13.916 2.045 2.045 2.045h18.41c1.13 0 2.045-.916 2.045-2.045V9.136c0-1.13-.916-2.045-2.046-2.045z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M12 17.319a4.09 4.09 0 100-8.182 4.09 4.09 0 000 8.181z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconCamera;
